import { Shimmer } from '@wartek-id/shimmer'

import Accordion from './Accordion'
import DataBlockLoading from './DataBlockLoading'
import DataBlock from './DataBlock'
import DataInfo from './DataInfo'
import { formatDate } from 'utils/datetime'
import {
  getIsValidData,
  getIsValidCertificate,
} from './helpers/data-validation'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

interface BlockCertificationProps {
  isLoading?: boolean
  data: IBCKSKepalaSekolahEligibility['certificate']
}

const BlockCertification: FC<BlockCertificationProps> = ({
  isLoading = false,
  data,
}) => {
  const isValidNoSertifikatPendidik = getIsValidData(
    data?.nomorSertifikatPendidik
  )

  return (
    <Accordion
      isLoading={isLoading}
      title="Sertifikasi"
      isError={!isLoading && !getIsValidCertificate(data)}
    >
      <div className="space-y-4">
        {isLoading && (
          <>
            {Array.from({ length: 7 })?.map((_, index) => (
              <DataBlockLoading
                index={index}
                key={`loading-shimmer-identity-${index}`}
              />
            ))}
            <div className="bg-surface-subdued px-4 py-3 rounded">
              <Shimmer width="100%" />
            </div>
          </>
        )}

        {!isLoading && (
          <>
            <DataBlock
              label="No. Sertifikat Pendidik"
              errorMessage={
                data.nomorSertifikatPendidik.validation ||
                data.tanggalSertifikatPendidik.validation
              }
            >
              {isValidNoSertifikatPendidik &&
                data.nomorSertifikatPendidik.value}
              {isValidNoSertifikatPendidik &&
                !!data.tanggalSertifikatPendidik.value && (
                  <>
                    <br />
                    Terbit {formatDate(data.tanggalSertifikatPendidik.value)}
                  </>
                )}
            </DataBlock>

            <DataInfo />
          </>
        )}
      </div>
    </Accordion>
  )
}
export default BlockCertification
